import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { forgotPassword } from '../features/auth/authSlice';
import { Link } from 'react-router-dom';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const dispatch = useDispatch();
  const { forgotPasswordStatus, forgotPasswordError } = useSelector(state => state.auth);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(forgotPassword(email));
  };

  return (
    <div className="row justify-content-center">
      <div className="col-md-5">
        <div className="card border-0 shadow-lg">
          <div className="card-body p-5">
            <div className="text-center mb-4">
              <div style={{ fontSize: '3.5rem' }}>🔑</div>
              <h2 className="mt-3">Forgot Password</h2>
              <p className="text-muted">Enter your email to receive a reset link</p>
            </div>

            {forgotPasswordStatus === 'succeeded' && (
              <div className="alert alert-success d-flex align-items-center" role="alert">
                <span className="me-2">✅</span>
                <div>If an account with that email exists, a password reset link has been sent.</div>
              </div>
            )}

            {forgotPasswordStatus === 'failed' && (
              <div className="alert alert-danger d-flex align-items-center" role="alert">
                <span className="me-2">⚠️</span>
                <div>{forgotPasswordError}</div>
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label className="form-label fw-bold">📧 Email Address</label>
                <input
                  className="form-control form-control-lg"
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  disabled={forgotPasswordStatus === 'loading'}
                  placeholder="your.email@example.com"
                  required
                />
              </div>
              <button
                className="btn btn-lg w-100 text-white fw-bold"
                style={{
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                }}
                type="submit"
                disabled={forgotPasswordStatus === 'loading'}
              >
                {forgotPasswordStatus === 'loading' ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                    Sending...
                  </>
                ) : (
                  <>Send Reset Link →</>
                )}
              </button>
            </form>

            <div className="mt-3 text-center">
              <Link to="/login">← Back to Login</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
